module.exports = __webpack_public_path__ + "img/huiqizi.4eb6707d.png";